module.exports = __webpack_public_path__ + "static/media/02_tearsofhair.30cfdda9.jpg";